import { FirewallRule, RulePosition } from '@xver/@types/firewall-rule';
import { CreateFirewallVMRuleRequest, FirewallVMRuleResponse } from '@xver/@types/firewall-vm-rule';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    LIST: (instanceId: any) => `/v1/firewalls/instances/${instanceId}/rules`,
    CREATE: (instanceId: any) => `/v1/firewalls/instances/${instanceId}/rules`,
    UPDATE: (instanceId: any, position: number) =>
        `/v1/firewalls/instances/${instanceId}/rules/${position}`,
    DELETE: (instanceId: any, position: number) =>
        `/v1/firewalls/instances/${instanceId}/rules/${position}`,
    DELETE_SECURITY_GROUP_RULES: (instanceId: any, securityGroupId: string) =>
        `/v1/firewalls/instances/${instanceId}/rules/security-group/${securityGroupId}`,
    BATCH_DELETE: (instanceId: any) => `/v1/firewalls/instances/${instanceId}/rules/batch-delete`,
    MOVE: (instanceId: any, position: number, target: number) =>
        `/v1/firewalls/instances/${instanceId}/rules/${position}/move?target=${target}`,
};

export function listRules(instanceId: any): Promise<FirewallVMRuleResponse> {
    return httpClient.get(ENDPOINTS.LIST(instanceId));
}

export function createRule(instanceId: any, data: CreateFirewallVMRuleRequest): Promise<undefined> {
    return httpClient.post(ENDPOINTS.CREATE(instanceId), data);
}

export function updateRule(instanceId: any, data: FirewallRule & RulePosition): Promise<undefined> {
    return httpClient.put(ENDPOINTS.UPDATE(instanceId, data.position), data);
}

export function deleteRule(instanceId: any, position: number): Promise<undefined> {
    return httpClient.delete(ENDPOINTS.DELETE(instanceId, position));
}

export function deleteSecurityGroupRules(
    instanceId: any,
    securityGroupId: string
): Promise<undefined> {
    return httpClient.delete(ENDPOINTS.DELETE_SECURITY_GROUP_RULES(instanceId, securityGroupId));
}

export function batchDeleteRules(instanceId: any, positions: number[]): Promise<undefined> {
    return httpClient.post(ENDPOINTS.BATCH_DELETE(instanceId), { data: { positions } });
}

export function moveRulePosition(
    instanceId: any,
    position: number,
    target: number
): Promise<undefined> {
    return httpClient.post(ENDPOINTS.MOVE(instanceId, position, target));
}
